module.exports = __webpack_public_path__ + "static/4-8d075344ff053f5bd266d70c5f89d3a4.jpg";